<template>
    <div>
        <div
            class="bg w-full h-screen overflow-y-auto flex items-center justify-center bg-no-repeat bg-center bg-cover pt-48"
        >
            <div
                class="p-24 md:p-32 w-full max-w-[85%] sm:max-w-[400px] bg-white rounded-6 shadow-custom flex flex-col items-center z-10 self-start md:self-center"
                :class="$route.name === 'register' ? 'max-w-640' : 'max-w-480'">

                <h1 class="text-heading-1 font-semibold leading-none text-black">
                    Jobtoolz
                </h1>
                <h2 class="text-heading-2 text-secondary mb-24 font-semibold leading-none">
                    {{ $t('auth.forgot_password_title') }}
                </h2>

                <form @submit.prevent="handleSubmit" @keydown.enter.prevent="handleSubmit" @keydown.esc="handleReset">

                    <input-component
                        class="w-320 mb-16"
                        type="email"
                        v-model="form.email"
                        placeholder="john.doe@example.com"
                        required
                    >
                        {{ $t('auth.your_email') }}:
                    </input-component>

                    <div v-if="hasErrors" class="mb-16 self-start">
                        <ul class="text-semantic-error font-semibold pl-24">
                            <li v-for="(error, index) in allErrors" :key="index">
                                {{ error }}
                            </li>
                        </ul>
                    </div>

                    <simple-button
                        :loading="form.submitting"
                        type="submit"
                        :display="form.email ? 'secondary' : 'primary'"
                        look="primary"
                        class="w-full mb-16"
                        :disabled="!form.email"
                    >
                        {{ $t('auth.send_password_reset_link') }}
                    </simple-button>

                    <button
                        class="underline text-primary-60 trans-ease hover:text-primary block mx-auto"
                        @click.prevent="gotoLogin"
                    >{{ $t('auth.login') }}
                    </button>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '../etc/forms/Form';
import Input from '../components/forms/Input.vue';
import SimpleButton from '../components/ui/SimpleButton.vue';
import values from 'lodash/values';
import flatten from 'lodash/flatten';
import * as users from '../services/UserService';
import { ADD_NOTIFICATION } from '../state/mutation-types';
import SvgIcon from "../components/ui/SvgIcon.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";
import {useNotificationsStore} from "../state/modules/notifications";

export default {
    components: {
        SvgIcon,
        'input-component': Input,
        'simple-button': SimpleButton,
    },
    head() {
        return {
            title: this.$t('auth.forgot_password'),
        }
    },
    data: function () {
        return {
            form: new Form([
                { name: 'email', value: '', rules: []},
            ]),
        }
    },
    computed: {
        ...mapStores(useNotificationsStore),
        hasErrors () {
            return values(this.form.errors).some(errors => errors !== undefined);
        },
        allErrors () {
            return flatten(values(this.form.errors).filter(error => error && error.length));
        },
    },
    methods: {
        handleSubmit () {
            this.form.submit(data => users.requestResetLink(data.email))
                .then(response => {
                    this.notificationsModuleStore[ADD_NOTIFICATION]({
                        type: 'success',
                        message: this.$t('auth.password_reset_link_sent', { email: this.form.email }),
                    });
                })
                .then(() => {
                    this.form.email = '';
                })
                .catch(error => {});
        },
        handleReset () {
            this.form.reset();
        },
        gotoLogin () {
            this.$router.push({ name: 'login'});
        },
    },
}
</script>
